<template>
  <div class="indeCenZ">
    <div class="cenZtop"><img src="../assets/img/zhao-top.png" alt="招聘"></div>
    <ul>
      <li>
        <div><img src="../assets/img/zhao-cen1.png" alt="项目经理"><h4>项目经理</h4></div>
        <p>负责渠道入口，业务产品组合运营，制定运营策略，对结果负责，负责从产品需求、入口设计、产品策划到线上的规划与推动，制定推广计划并完成目标，负责运营数据及客户反馈收集并优化，渠道产品对接与维护。</p>
      </li>
      <li>
        <div><img src="../assets/img/zhao-cen2.png" alt="java开发工程师"><h4>java开发工程师</h4></div>
        <p>参与综合平台新功能开发、需求完善渠道接入等工作；围绕生活号、支付宝微信小程序、微信公众号、功能开发。</p>
      </li>
      <li>
        <div><img src="../assets/img/zhao-cen3.png" alt="行政专员"><h4>行政专员</h4></div>
        <p>负责公司人才招聘、培训、入/离职劳务合同、考勤表、工资表、社保以及保管资料等日常事宜；负责公司物品资产的登记保管、会议、环境卫生、网、水、电、物业缴费、部门资料打印及其他事项。</p>
      </li>
      <li>
        <div><img src="../assets/img/zhao-cen4.png" alt="运营专员"><h4>运营专员</h4></div>
        <p>负责产品渠道推广，跟踪数据及分析投放效果与优化，渠道发掘、对接、测试、运营，竞品分析及制定策略，产品方案的参与制定及实施。</p>
      </li>
      <li>
        <div><img src="../assets/img/zhao-cen5.png" alt="会计"><h4>会计</h4></div>
        <p>负责公司各项业务收支核对，进出账及天猫财务核算，日常报销借支处理，票据核对，外账对接，利润及薪酬核算，银行及税务、开户等工作。</p>
      </li>
      <li>
        <div><img src="../assets/img/zhao-cen6.png" alt="电商客服"><h4>电商客服</h4></div>
        <p>负责线上各大平台的日常接待及发货电话任务拨打和旺旺任务执行，配合业务需求为培养运营打基础，人员后期可培养为运营。</p>
      </li>
    </ul>
    <p class="beianPtips"><span @click="goBeian">陕ICP备15007224号  出版物网络交易平台服务经营备案号：新出发批兼零字第023号</span></p>
    <p class="bottomTips">联系电话：15829614885<span></span>企业邮箱：xjgw@xi-9.com<span></span>地址：西安市高新区唐延南路逸翠尚府北区一栋楼四单元四层</p>
  </div>
</template>

<script>
  export default {
  	name: 'indexCenterZ',
  	data () {
  		return {

  		}
  	},
    mounted:function(){
    },
  	methods:{
      goBeian(){
        window.location.href = 'http://www.beian.miit.gov.cn';
      },
  	}
  }
</script>

<style scoped lang="scss">
  .indeCenZ{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .beianPtips{
      display: block;
      position: absolute;
      left: 0;
      bottom: 2rem;
      width: 100%;
      color: #3a3a3a;
      text-align: center;
      span{
        margin: 0;
        padding: 0;
        border: none;
      }
      span:hover{
        color: #000;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .cenZtop{
      background: url(../assets/img/zhao-bg.png) no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 20rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 40rem;
      }
    }
    ul{
      width: 60%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 1rem;
      li{
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: start;
        padding-bottom: 1rem;
        div{
          display: flex;
          align-items: center;
          margin-top: 2rem;
          margin-bottom: 1rem;
          img{
            width: 2rem;
            margin-right: 1rem;
          }
          h4{
            font-size: 1.2rem;
          }
        }
        p{
          padding: 0 3.2rem;
          text-align: justify;
          text-indent: 2rem;
          margin: 0;
          font-size: .9rem;
          line-height: 1.4rem;
          color: #a4a4a4;
        }
      }
    }
    p{
      color: #a4a4a4;
      margin-top: 5rem;
      margin-bottom: 1rem;
      display: flex;
      line-height: 1.4rem;
      font-size: .9rem;
      span{
        margin-left: .8rem;
        padding-left: .8rem;
        border-left: 1px solid #a4a4a4;
      }
    }
    @media screen and (max-width: 1700px) {
      ul{
        width: 80%;
      }
    }
    @media screen and (max-width: 1300px) {
      ul{
        width: 90%;
      }
    }
    @media screen and (max-width: 1100px) {
      .cenZtop{
        img{
          width: 60%;
        }
      }
      ul{
        li{
          width: 50%;
        }
      }
    }
    @media screen and (max-width: 1000px) {
      p{
        flex-direction: column;
        align-items: center;
        span{
          border: none;
        }
      }
    }
    @media screen and (max-width: 600px) {
      .cenZtop{
        height: 12rem;
        img{
          width: 80%;
        }
      }
      ul{
        li{
          width: 100%;
        }
      }
      p{
        margin-top: 3rem;
        font-size: .8rem;
      }
      .beianPtips{
        bottom: 4.2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexCenterZ.vue